<template>
  <header class="web-header">
    <div class="web-ad" @click="linkBgUrl"></div>

    <div class="web-web-header">
      <!-- 顶部 start -->
      <div class="web-main header-top clear">
        <!-- logo -->
        <img src="../assets/images/common/logo.png" alt="" class="header-logo lf">
        <!-- 图片 -->
        <img src="../assets/images/common/header.png" alt="" class="header-img lf">
        <div class="header-user rf">
          <!-- app -->
          <div class="header-app lf" @mouseover="downloadShow" @mouseout="downloadHide">
            <div class="app-logo lf">APP</div>
            <img src="../assets/images/common/triangle.png" alt="" class="app-img rf">
            <div class="header-download">
              <img src="../assets/images/common/download.png" alt="">
            </div>
          </div>
          <!-- 搜索 -->
          <div class="header-search lf">
            <input type="text" class="lf" placeholder="搜索站内资讯、视频" v-model="searchKeyWord">
            <div class="search-button lf"></div>
            <div class="search-hidden">
              <ul v-if="searchShow=='show'">
                <li class="search-items ellipsis" v-for="(item,index) in searchList" :key="index" v-html="item.title"
                  @click="goDetials(item.id,item.p0,item.webUrl)"></li>
              </ul>
              <div class="web-space" v-if="searchShow=='hide'">
                <img src="../assets/images/common/space.png" alt="">
              </div>
            </div>
          </div>
          <!-- 登录 -->
          <div class="header-login rf" v-show="!$store.state.user.loginStatus">
            <div class="login" @click.stop="goRegister">注册</div>
            <div class="line"></div>
            <div class="login" @click.stop="goLogin">登录</div>
          </div>
          <!-- 登录 -->
          <div class="login-avatar rf" v-show="$store.state.user.loginStatus">
            <el-dropdown @command="linkUser">
              <div class="avatar img">
                <img :src="avatarLogo" alt="">
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="ellipsis">{{$store.state.user.userInfo.realName}}</el-dropdown-item>
                <el-dropdown-item :command="'/my'">个人中心</el-dropdown-item>
                <el-dropdown-item :command="'/set'">意见反馈</el-dropdown-item>
                <el-dropdown-item :command="'/logout'">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- 顶部 end -->
      <!-- 导航按钮 -->
      <div class="header-nav-btn"></div>
      <!-- 导航 start -->
      <nav class="header-nav">
        <el-menu class="web-main" :default-active="activeIndex" mode="horizontal" background-color="#131313"
          text-color="#FFFFFF" active-text-color="#FFFFFF" router>
          <el-menu-item class="nav-items" v-for="item in navList" :key="item.path" :index="item.path"
            @click="changeActiveIndexWeb(item.path)">
            <div class="items">{{item.name}}</div>
          </el-menu-item>
        </el-menu>
      </nav>
      <!-- 导航 end -->
    </div>
    <!-- 移动端 -->
    <div class="web-phone-header">
      <nav class="phone-nav-top">
        <div class="phone-nav">
          <img src="../assets/images/common/logo.png" alt="" class="phone-logo">
        </div>
        <div class="phone-search">
          <input class="search" type="text" placeholder="搜索站内资讯、视频" v-model="searchKeyWord">
          <div class="btn"></div>
          <div class="search-hidden">
            <ul v-if="searchShow=='show'">
              <li class="search-items ellipsis" v-for="(item,index) in searchList" :key="index" v-html="item.title"
                @click="goDetials(item.id,item.p0,item.webUrl)"></li>
            </ul>
            <div class="web-space" v-if="searchShow=='hide'">
              <img src="../assets/images/common/space.png" alt="">
            </div>
          </div>
        </div>
      </nav>
      <nav class="phone-nav-box">
        <div class="phone-nav" @click="navShow">
          <span class="line line1"></span>
          <span class="line line2"></span>
        </div>
        <div class="phone-nav" v-show="!$store.state.user.loginStatus">
          <span @click.stop="goLogin">登录</span>
          <span> | </span>
          <span @click.stop="goRegister">注册</span>
        </div>
        <div class="login-avatar" v-show="$store.state.user.loginStatus">
          <el-dropdown @command="linkUser">
            <div class="avatar img">
              <img :src="avatarLogo" alt="">
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="ellipsis">{{$store.state.user.userInfo.realName}}</el-dropdown-item>
              <el-dropdown-item :command="'/my'">个人中心</el-dropdown-item>
              <el-dropdown-item :command="'/set'">意见反馈</el-dropdown-item>
              <el-dropdown-item :command="'/logout'">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </nav>
      <div class="phone-navhidden">
        <el-menu :default-active="activeIndex" background-color="#131313" text-color="#FFFFFF"
          active-text-color="#FFFFFF" router>
          <el-menu-item class="nav-items" v-for="item in navList" :key="item.path" :index="item.path"
            @click="changeActiveIndex(item.path)">
            <div class="items">{{item.name}}</div>
          </el-menu-item>
        </el-menu>
      </div>
    </div>


    <el-dialog :title="loginDialogTitle" :visible.sync="$store.state.user.loginShow" @close="closeDialog">
      <!-- 登录框 start -->
      <el-form ref="loginForm" :model="loginData" :rules="rulesLogin" v-show="loginShow=='login'">
        <el-form-item class="border work-dialog-item" prop="phone">
          <el-input v-model="loginData.phone" autocomplete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item class="border work-dialog-item" prop="pass">
          <el-input v-model="loginData.pass" type="password" autocomplete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item class="remember-pass">
          <el-checkbox v-model="rememberPass" @change="changeRememberPass">记住密码</el-checkbox>
          <div class="forget-pass rf" @click.stop="forgetPass">忘记密码？</div>
        </el-form-item>
      </el-form>
      <!-- 登录框 end -->

      <!-- 注册框 start -->
      <el-form :model="regiterData" ref="registerForm" :rules="rulesRegister" v-show="loginShow=='register1'">
        <el-form-item class="border work-dialog-item" prop="phone">
          <el-input v-model="regiterData.phone" autocomplete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item class="border work-dialog-item">
          <el-input v-model="regiterData.code" autocomplete="off" placeholder="验证码"></el-input>
        </el-form-item>
        <el-form-item class="get-code-box">
          <div class="get-code rf" @click="getRegisterCode">{{registerCodeMessage}}</div>
        </el-form-item>
      </el-form>
      <!-- 注册框 end -->
      <!-- 注册框2 start -->
      <el-form :model="regiterData" ref="registerForm2" :rules="rulesRegister" v-show="loginShow=='register'">
        <el-form-item class="border work-dialog-item" prop="newpass">
          <el-input v-model="regiterData.newpass" type="password" autocomplete="off" placeholder="输入新密码"></el-input>
        </el-form-item>
        <el-form-item class="border work-dialog-item">
          <el-input v-model="newpassConfirm" type="password" autocomplete="off" placeholder="确认新密码"></el-input>
        </el-form-item>
        <el-form-item class="get-code-box">
        </el-form-item>
      </el-form>
      <!-- 注册框2 end -->

      <!-- 忘记密码 start -->
      <el-form :model="PassData" ref="passForm" :rules="rulesPass" v-show="loginShow=='pass1'">
        <el-form-item class="border work-dialog-item" prop="phone">
          <el-input v-model="PassData.phone" autocomplete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item class="border work-dialog-item">
          <el-input v-model="PassData.code" autocomplete="off" placeholder="验证码"></el-input>
        </el-form-item>
        <el-form-item class="get-code-box">
          <div class="get-code rf" @click="getPassCode">{{passCodeMessage}}</div>
        </el-form-item>
      </el-form>
      <!-- 忘记密码 start -->

      <!-- 忘记密码2 start -->
      <el-form :model="PassData" ref="passForm2" :rules="rulesPass" v-show="loginShow=='pass2'">
        <el-form-item class="border work-dialog-item" prop="newpass">
          <el-input v-model="PassData.newpass" type="password" autocomplete="off" placeholder="输入新密码"></el-input>
        </el-form-item>
        <el-form-item class="border work-dialog-item">
          <el-input v-model="newpassConfirm" type="password" autocomplete="off" placeholder="确认新密码"></el-input>
        </el-form-item>
        <el-form-item class="get-code-box">
        </el-form-item>
      </el-form>
      <!-- 忘记密码2 end -->

      <div slot="footer" class="dialog-footer">
        <div class="dialog-btn" @click="loginSubmit" v-show="loginShow=='login'" v-loading="loginLoading">登录</div>
        <div class="dialog-btn" @click="registerSubmit" v-show="loginShow=='register'" v-loading="registerLoading">注册
        </div>
        <div class="dialog-btn" @click="nextPass" v-show="loginShow=='register1' || loginShow=='pass1'">提交</div>
        <div class="dialog-btn" @click="passSubmit" v-show="loginShow=='pass2'" v-loading="passLoading">完成</div>
        <!-- 社交账号登录 start -->
        <!-- <p class="third-account-title">社交账号登录</p>
        <div class="third-account-img">
          <img src="../assets/images/common/qq.png" alt="">
          <img src="../assets/images/common/wechat.png" alt="">
          <img src="../assets/images/common/blog.png" alt="">
        </div> -->
        <!-- 社交账号登录 end -->
        <div class="login-regiater" @click="goRegister" v-show="loginShow=='login'">没有账号，立即<span>注册</span></div>
        <div class="login-regiater" @click="goLogin" v-show="loginShow!=='login'">已有账号，马上<span>登录</span></div>
      </div>
    </el-dialog>

  </header>
</template>

<script>
  import validate from '@/rule' // 校验规则方法
  import axios from "axios"
  export default {
    name: "web-header",
    data() {
      let required = validate.required();
      let mobile = validate.mobile();
      // let formatPwd = validate.formatPwd('密码为8-18位，包含大小写、数字和符号');
      return {
        bgLink: "",
        avatarLogo: "", //头像
        loginDialogTitle: "登录",
        loginShow: "login", //登录框显示--login-登录框 register-注册框 pass1-密码框1 pass2-密码框2
        rememberPass: localStorage.getItem(this.$store.state.sys._storage + "remember") ? true : false, //是否记住密码
        activeIndex: "/home",
        navList: [{
            name: "首页",
            path: "/home"
          },
          {
            name: "新闻资讯",
            path: "/news"
          },
          {
            name: "媒体视听",
            path: "/media"
          },
          {
            name: "中阳生活",
            path: "/live"
          },
          {
            name: "乡镇机关",
            path: "/country"
          },
          {
            name: "个人中心",
            path: "/my"
          }
        ],
        navFlag: true, // 移动端是否显示列表
        // 登录数据
        loginData: {
          phone: "",
          pass: "",
        }, // 登录数据
        rulesLogin: { // 校验规则
          phone: [required, mobile],
          pass: [required],
        },
        loginLoading: false, //登录加载
        // 注册数据
        regiterData: {
          phone: "", //手机号
          code: "", //验证码
          newpass: "" //新密码
        }, //注册数据
        rulesRegister: {
          phone: [required, mobile],
          newpass: [required]
        },
        registerCode: "", //后台获取到的注册验证码
        registerSecret: "", //后台获取到的注册密码串
        registerCodeMessage: "获取验证码",
        registerCodeClick: true, //获取验证码是否可以点击
        registerLoading: false, //注册加载
        // 忘记密码数据
        PassData: {
          phone: "",
          code: "",
          newpass: ""
        }, //忘记密码数据
        rulesPass: {
          phone: [required, mobile],
          newpass: [required]
        },
        passCodeMessage: "获取验证码",
        passCodeClick: true, //获取验证码是否可以点击
        passLoading: false, //修改密码加载
        newpassConfirm: "", //确认密码
        resetSecret: "", //后台获取到的修改验证码
        resetCode: "", //后台获取到的修改密码串
        timer: null, //倒计时

        searchList: [], //搜索列表
        searchLoading: false, //搜索加载
        searchKeyWord: "", //搜索关键词
        searchShow: "", //show-显示列表 hide-显示默认图片

        hasBg: false //是否有背景
      }
    },
    //利用计算属性
    computed: {
      loginStatus() {
        return this.$store.state.user.loginStatus;
      }
    },
    watch: {
      $route: function(to, from) {
        this.activeIndex = this.$route.matched[0].path;
        if (this.activeIndex == '') {
          this.activeIndex = '/home'
        }
        $(".web-phone-header .line1").css({
          transform: "translate(0,0px) rotate(0deg)"
        });
        $(".web-phone-header .line2").css({
          transform: "translate(0,0px) rotate(0deg)"
        });
        $(".web-phone-header .phone-navhidden").slideUp();
        this.navFlag = true;
        this.getBg();
      },
      loginStatus(val) {
        this.getUserLogo();
      },
      searchKeyWord(val) {
        this.goSearch(val);
      }
    },
    mounted() {
      // 记住密码后的用户名密码
      if (localStorage.getItem(this.$store.state.sys._storage + "remember")) {
        let userRemember = JSON.parse(localStorage.getItem(this.$store.state.sys._storage + 'userRemember'));
        this.loginData.phone = userRemember.phone;
        this.loginData.pass = userRemember.pass;
      }
      this.activeIndex = this.$route.matched[0].path
      if (this.activeIndex == '') {
        this.activeIndex = '/home'
      }
      this.getUserLogo();
      this.getBg();
    },
    methods: {
      // 获取背景 start
      // getBg() {
      //   console.log('bg')
      //   if (this.$route.matched[1].name == "/home") {
      //     this.loading = true;
      //     let that = this;
      //     console.log(this.$api.getadInfo)
      //     this.getAjax(this.$api.getadInfo, {
      //       number: this.$apiId.bodyAd
      //     }, function(res) {
      //       console.log(res)
      //       if (res.code == 1) {
      //         let list = res.list;
      //         if (list.length > 0) {
      //           that.hasBg = true;
      //           $("#app").addClass("body-bg");
      //           let image = list[0].image;
      //           $("#app").css("background-image", "url(" + image + ")");
      //           let link = list[0].text;
      //           if (link.indexOf("http") !== -1) {
      //             that.bgLink = link;
      //           }
      //         }
      //       }
      //       that.loading = false;
      //     }, function() {
      //       that.loading = false;
      //     })
      //   } else {
      //     if (this.hasBg) {
      //       $("#app").removeClass("body-bg");
      //       $("#app").css("background-image", "none");
      //       this.hasBg = false;
      //     }
      //   }
      // },
      getBg() {
        if (this.$route.matched[1].name == "/home") {
          this.loading = true;
          let that = this;
          this.getAjax(this.$api.getnodeColumnDetail, {
            // number: that.$apiId.bodyAd
            nodeId: that.$apiId.bodyAdId
          }, function(res) {
            console.log(res)
            if (res.code == 1) {
              let data = res.data;
              if (data.number == that.$apiId.bodyAd) {
                let image = data.largeImage || data.url;
                if (image !== "") {
                  that.hasBg = true;
                  $("#app").addClass("body-bg");
                  let link = data.webUrl;
                  if (link.indexOf("http") !== -1) {
                    that.bgLink = link;
                  }
                  $("#app").css("background-image", "url(" + image + ")");
                }
              }
            }
            that.loading = false;
          }, function() {
            that.loading = false;
          })
        } else {
          if (this.hasBg) {
            $("#app").removeClass("body-bg");
            $("#app").css("background-image", "none");
            this.hasBg = false;
          }
        }
      },
      // 获取背景 end
      // 跳转背景链接 start
      linkBgUrl() {
        if (this.bgLink !== "") {
          window.open(this.bgLink, '_blank');
        }
      },
      // 跳转背景链接 end
      // 搜索 start
      goSearch(val) {
        let keyword = val.trim();
        if (keyword == '') {
          $('.search-hidden').slideUp();
          this.searchList = [];
          return;
        }
        this.searchLoading = true;
        $('.search-hidden').slideDown();
        let that = this;
        this.getAjax(this.$api.getarticleList, {
          pageNoNum: 1,
          pageSizeNum: 10,
          title: keyword
        }, function(res) {
          if (res.code == 1) {
            let data = res.list;
            if (res.page.total > 0) {
              that.searchShow = "show";
              // 匹配关键字正则
              let replaceReg = new RegExp(keyword, 'g');
              for (let i in data) {
                // 高亮替换v-html值
                let replaceString = '<span>' + keyword + '</span>';
                // 开始替换
                data[i].title = data[i].title.replace(replaceReg, replaceString);
              }
            } else {
              that.searchShow = "hide";
            }
            that.searchList = data;
          }
          that.searchLoading = false;
        }, function() {
          that.searchLoading = false;
        })
      },
      // 搜索 end
      // 跳转到新闻详情页面
      goDetials(id, p0, webUrl) {
        this.searchKeyWord = "";
        $(".search-hidden").hide();
        this.skipNewsDetials(id, p0, webUrl);
      },
      getUserLogo() {
        if (this.$store.state.user.loginStatus) {
          let userInfo = this.$store.state.user.userInfo;
          if (userInfo.icon) {
            this.avatarLogo = userInfo.icon;
          } else {
            this.avatarLogo = require("../assets/images/common/avatar.png");
          }
        }
      },
      changeActiveIndex(route) {
        $(".web-phone-header .line1").css({
          transform: "translate(0,0px) rotate(0deg)"
        });
        $(".web-phone-header .line2").css({
          transform: "translate(0,0px) rotate(0deg)"
        });
        $(".web-phone-header .phone-navhidden").slideUp();
        this.navFlag = true;
        this.changeActiveIndexWeb(route);
      },
      changeActiveIndexWeb(route) {
        if (!this.$store.state.user.loginStatus) {
          // 如果未登录且已经点击了个人中心按钮--个人中心不高亮显示，原来的高亮显示
          if (this.$store.state.user.navClick) {
            // 如果点击了个人中心
            $(".nav-items").removeClass('is-active');
            this.$store.dispatch('MYSET', false);
          }
          if (route == "/my") {
            this.$store.dispatch('MYSET', true); //点击了个人中心
            $(".nav-items").eq(5).addClass('is-active');
          }
        } else {
          // 如果已经登录
          if (this.$store.state.user.navClick) {
            // 如果点击了个人中心
            $(".nav-items").removeClass('is-active');
            if (route == "/my") {
              $(".nav-items").eq(5).addClass('is-active');
            }
            this.$store.dispatch('MYSET', false);
          }
        }
      },
      // 下载显示
      downloadShow() {
        $('.header-download').show();
      },
      // 下载隐藏
      downloadHide() {
        $('.header-download').hide();
      },
      // 关闭dialog
      closeDialog() {
        if (localStorage.getItem(this.$store.state.sys._storage + "remember")) {
          let userInfo = {
            phone: this.loginData.phone,
            pass: this.loginData.pass
          }
          localStorage.setItem(this.$store.state.sys._storage + 'userRemember', JSON.stringify(userInfo));
        } else {
          this.loginData = {
            phone: "",
            pass: ""
          }
        }
        clearInterval(this.timer);
        this.registerCodeMessage = "获取验证码";
        this.passCodeMessage = "获取验证码";
        this.regiterData = {
          phone: "",
          code: ""
        };
        this.PassData = {
          phone: "",
          code: "",
          newpass: ""
        };
        this.newpassConfirm = "";
        this.loginShow = 'login';
        this.loginDialogTitle = "登录";
        if (this.$store.state.user.navClick) {
          // 如果已经点击了个人中心按钮--个人中心不高亮显示，原来的高亮显示
          let index;
          if (this.activeIndex == "/home") {
            index = 0;
          } else if (this.activeIndex == "/news") {
            index = 1;
          } else if (this.activeIndex == "/media") {
            index = 2;
          } else if (this.activeIndex == "/live") {
            index = 3;
          } else if (this.activeIndex == "/country") {
            index = 4;
          }
          $(".nav-items").eq(5).removeClass('is-active');
          $(".nav-items").eq(index).addClass('is-active');
        }
      },
      // 点击注册
      goRegister() {
        this.$store.dispatch('LOGINSHOW', true);
        this.loginShow = 'register1';
        this.loginDialogTitle = "注册";
      },
      // 点击显示登录框
      goLogin() {
        this.$store.dispatch('LOGINSHOW', true);
        this.loginShow = 'login';
        this.loginDialogTitle = "登录";
      },
      // 点击显示忘记密码框
      forgetPass() {
        this.loginShow = 'pass1';
        this.loginDialogTitle = "忘记密码";
      },
      // 点击下一步修改密码
      nextPass() {
        this.newpassConfirm = "";
        let that = this;
        if (this.loginShow == 'register1') {
          // 注册获取验证码
          this.$refs['registerForm'].validate(valid => {
            if (valid) {
              if (that.regiterData.code == "" || that.regiterData.code.trim().length == 0) {
                that.errorMessage("请先填写验证码");
              } else if (that.regiterData.code == that.registerCode) {
                // 如果验证码一致
                that.loginShow = 'register';
                clearInterval(that.timer);
                that.registerCodeMessage = "获取验证码";
              } else {
                that.errorMessage("请填写正确的验证码");
              }
            }
          })
        } else {
          // 忘记密码获取验证码
          this.$refs['passForm'].validate(valid => {
            if (valid) {
              if (that.PassData.code == "" || that.PassData.code.trim().length == 0) {
                that.errorMessage("请先填写验证码");
              } else if (that.PassData.code == that.resetCode) {
                // 如果验证码一致
                that.loginShow = 'pass2';
                clearInterval(that.timer);
                that.passCodeMessage = "获取验证码";
              } else {
                that.errorMessage("请填写正确的验证码");
              }
            }
          })
        }
      },
      // 点击记住密码
      changeRememberPass() {
        if (this.rememberPass) {
          localStorage.setItem(this.$store.state.sys._storage + "remember", true);
          let userInfo = {
            phone: this.loginData.phone,
            pass: this.loginData.pass
          }
          localStorage.setItem(this.$store.state.sys._storage + 'userRemember', JSON.stringify(userInfo));
        } else {
          localStorage.removeItem(this.$store.state.sys._storage + "remember");
          localStorage.removeItem(this.$store.state.sys._storage + "userRemember");
        }
      },
      // 点击登录
      loginSubmit() {
        let that = this;
        this.$refs['loginForm'].validate(valid => {
          if (valid) { // 验证方法
            if (!that.loginLoading) {
              that.loginLoading = true;
              const Base64 = require('js-base64').Base64;
              let userPwd = Base64.encode(that.loginData.pass);
              userPwd = "h" + userPwd + "xt";
              // that.postAjax(that.$api.postUserLogin, {
              //   phone: that.loginData.phone,
              //   password: userPwd
              // }, function(res) {
              //   if (res.code == 1) {
              //     that.$store.dispatch('userLogin', res.data); //保存用户数据
              //     that.$store.dispatch('LOGINSHOW', false);
              //     that.successMessage("登录成功");
              //   }
              //   that.loginLoading = false;
              // }, function() {
              //   that.loginLoading = false;
              // })


              let ajaxUrl = that.$fetch.defaults.baseURL + that.$api.postUserLogin;
              let params = {
                siteId: 1,
                phone: that.loginData.phone,
                password: userPwd
              }
              $.ajax({
                type: 'POST',
                url: ajaxUrl,
                dataType: 'json',
                data: params,
                jsonp: 'callback',
                beforeSend: function(XMLHttpRequest) {
                  XMLHttpRequest.setRequestHeader("referer", ajaxUrl);
                },
                success(res) {
                  if (res.code == 1) {
                    that.$store.dispatch('userLogin', res.data); //保存用户数据
                    that.$store.dispatch('LOGINSHOW', false);
                    that.successMessage("登录成功");
                  }
                  that.loginLoading = false;
                },
                error(jqXHR, textStatus, errorThrown) {
                  // 错误信息处理
                  console.error(textStatus, errorThrown)
                  that.loginLoading = false;
                }
              });



            }
          }
        })
      },
      // 注册获取验证码
      getRegisterCode() {
        if (this.registerCodeClick) {
          clearInterval(this.timer);
          this.registerCodeMessage = "获取验证码";
          this.registerCodeClick = false;
          let that = this;
          this.$refs['registerForm'].validate(valid => {
            if (valid) { // 验证方法
              let countdown = 59;
              that.timer = setInterval(function() {
                if (countdown == 0) {
                  that.registerCodeMessage = "获取验证码";
                  countdown = 59;
                  clearInterval(that.timer);
                  that.registerCodeClick = true;
                } else {
                  that.registerCodeMessage = "重新发送(" + countdown + ")";
                  countdown--;
                }
              }, 1000)
              that.postAjax(that.$api.postUserSendSms, {
                phone: that.regiterData.phone,
                smsType: 2
              }, function(res) {
                that.registerSecret = res.data.secret;
                that.registerCode = res.data.smsCode;
              }, function() {

              })
            } else {
              that.registerCodeClick = true;
            }
          })
        }
      },
      // 点击注册
      registerSubmit() {
        let that = this
        this.$refs['registerForm2'].validate(valid => {
          if (valid) { // 验证方法
            if (!that.registerLoading) {
              that.registerLoading = true;
              if (that.regiterData.newpass == that.newpassConfirm) {
                that.postAjax(that.$api.postUserRegister, {
                  phone: that.regiterData.phone,
                  password: that.regiterData.newpass,
                  secret: that.registerSecret,
                  code: that.regiterData.code
                }, function(res) {
                  if (res.code == 1) {
                    that.successMessage("注册成功");
                    that.loginShow = 'login';
                    that.loginDialogTitle = "登录";
                    that.loginData.phone = that.regiterData.phone;
                    that.loginData.pass = that.regiterData.newpass;
                  }
                  that.registerLoading = false;
                }, function() {
                  that.registerLoading = false;
                })
              } else {
                this.errorMessage("请保证密码填写一致");
                that.registerLoading = false;
              }
            }
          }
        })
      },
      // 忘记密码获取验证码
      getPassCode() {
        if (this.passCodeClick) {
          clearInterval(this.timer);
          this.passCodeMessage = "获取验证码";
          this.passCodeClick = false;
          let that = this;
          this.$refs['passForm'].validate(valid => {
            if (valid) { // 验证方法
              let countdown = 59;
              that.timer = setInterval(function() {
                if (countdown == 0) {
                  that.passCodeMessage = "获取验证码";
                  countdown = 59;
                  clearInterval(that.timer);
                  that.passCodeClick = true;
                } else {
                  that.passCodeMessage = "重新发送(" + countdown + ")";
                  countdown--;
                }
              }, 1000)
              that.postAjax(that.$api.postUserSendSms, {
                phone: that.PassData.phone,
                smsType: 3
              }, function(res) {
                that.resetSecret = res.data.secret;
                that.resetCode = res.data.smsCode;
              }, function() {

              })
            } else {
              that.passCodeClick = true;
            }
          })
        }
      },
      // 点击完成修改密码
      passSubmit() {
        let that = this
        this.$refs['passForm2'].validate(valid => {
          if (valid) { // 验证方法
            if (!that.passLoading) {
              that.passLoading = true;
              if (that.PassData.newpass == that.newpassConfirm) {
                that.postAjax(that.$api.postUserResetPassword, {
                  phone: that.PassData.phone,
                  newPassword: that.PassData.newpass,
                  secret: that.resetSecret,
                  code: that.PassData.code
                }, function(res) {
                  if (res.code == 1) {
                    that.successMessage("修改密码成功");
                    that.loginShow = 'login';
                    that.loginDialogTitle = "登录";
                    that.loginData.phone = that.PassData.phone;
                    that.loginData.pass = that.PassData.newpass;
                  }
                  that.passLoading = false;
                }, function() {
                  that.passLoading = false;
                })
              } else {
                this.errorMessage("请保证密码填写一致");
                that.passLoading = false;
              }
            }
          }
        })
      },
      // 移动端显示隐藏列表
      navShow() {
        if (this.navFlag) {
          $(".web-phone-header .line1").css({
            transform: "translate(0,5px) rotate(45deg)"
          });
          $(".web-phone-header .line2").css({
            transform: "translate(0,-2px) rotate(135deg)"
          });
          $(".web-phone-header .phone-navhidden").slideDown();
          if (!this.$store.state.user.loginStatus && this.$store.state.user.navClick) {
            // 如果未登录且已经点击了个人中心按钮--个人中心不高亮显示，原来的高亮显示
            let index;
            if (this.activeIndex == "/home") {
              index = 0;
            } else if (this.activeIndex == "/news") {
              index = 1;
            } else if (this.activeIndex == "/media") {
              index = 2;
            } else if (this.activeIndex == "/live") {
              index = 3;
            } else if (this.activeIndex == "/country") {
              index = 4;
            }
            $(".phone-navhidden .nav-items").eq(5).removeClass('is-active');
            $(".phone-navhidden .nav-items").eq(index).addClass('is-active');
          }
          this.navFlag = false;
        } else {
          $(".web-phone-header .line1").css({
            transform: "translate(0,0px) rotate(0deg)"
          });
          $(".web-phone-header .line2").css({
            transform: "translate(0,0px) rotate(0deg)"
          });
          $(".web-phone-header .phone-navhidden").slideUp();
          this.navFlag = true;
        }
      },
      linkUser(val) {
        if (val == '/my') {
          // 跳转到个人中心页面
          this.routerLink('/my');
        } else if (val == '/set') {
          // 跳转到意见反馈页面
          this.routerLink('/my/opinion');
        } else if (val == '/logout') {
          // 退出登录
          if (this.activeIndex == '/my') {
            this.routerLink('/home');
          }
          this.$store.dispatch('LOGOUT', false);
        }
      }
    }
  }
</script>

<style scoped>
  /* 搜索列表 start */
  .search-hidden {
    position: absolute;
    top: 66px;
    left: 0;
    width: 100%;
    background-color: #FFFFFF;
    box-shadow: 3px 3px 15px 1.7px rgba(28, 28, 28, 0.29);
    z-index: 1000;
    border-radius: 4px;
    padding: 15px 0;
    display: none;
  }

  .search-items {
    height: 35px;
    line-height: 35px;
    padding: 0 19px;
    font-size: 16px;
    letter-spacing: 0.8px;
    margin: 4px 0;
    cursor: pointer;
  }

  .search-items:hover {
    background-color: #F7F8F8;
  }

  .search-hidden .web-space img {
    width: 200px;
  }

  /* 搜索列表 end */
  .login-avatar {
    margin: 25px 0 0 20px;
    cursor: pointer;
  }

  .login-avatar .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
  }

  .el-dropdown-menu {
    width: 200px;
    padding: 0;
  }

  .el-dropdown-menu__item {
    height: 48px;
    border-top: 1px solid #DCDCDC;
    font-size: 20px;
    color: #333333;
    line-height: 48px;
  }

  .el-dropdown-menu__item:first-child,
  .el-dropdown-menu__item:last-child {
    border-top: none;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: transparent;
    color: #0861D1;
  }

  /* 顶部 start */
  header {
    background-color: #FFFFFF;
  }

  .header-top {
    height: 90px;
  }

  .header-top .header-logo {
    width: 60px;
    height: 60px;
    margin-left: 10px;
    margin-top: 15px;
  }

  .header-top .header-img {
    height: 100%;
    margin-left: 30px;
    opacity: 0.8;
  }

  .header-top .header-app {
    width: 90px;
    cursor: pointer;
    position: relative;
  }

  .header-top .app-logo {
    padding-left: 30px;
    height: 100%;
    line-height: 90px;
    font-size: 20px;
    font-weight: 400;
    color: #0861D1;
    background-image: url(../assets/images/common/phone.png);
    background-size: 28px 28px;
    background-repeat: no-repeat;
    background-position: left center;
  }

  .header-top .app-img {
    width: 15px;
    height: 7px;
    transition: all .3s;
    margin-top: 42px;
  }

  .header-top .app-img.active {
    transform: rotate(-90deg);
  }

  .header-top .header-download {
    width: 165px;
    height: 165px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 70px;
    right: 0;
    z-index: 999;
    padding: 18px;
    display: none;
  }

  .header-top .header-download img {
    width: 100%;
    height: 100%;
  }

  .header-top .header-search {
    width: 299px;
    height: 100%;
    margin-left: 16px;
    padding: 25px 0;
    position: relative;
  }

  .header-top input {
    width: 255px;
    height: 40px;
    line-height: 40px;
    background-color: #DCDCDC;
    border: 2px solid transparent;
    outline: none;
    border-radius: 5px 0 0 5px;
    padding: 0 7px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }

  .header-top input:focus {
    border-color: #0861D1;
  }

  .header-top .search-button {
    width: 44px;
    height: 40px;
    background-color: #0861D1;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
    background-image: url(../assets/images/common/search.png);
    background-repeat: no-repeat;
    background-size: 60%;
    background-position: center center;
  }

  .header-top .header-login {
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
  }

  .header-login .login {
    width: 20px;
    font-size: 18px;
    font-weight: 400;
    color: #595757;
    text-align: center;
    line-height: 18px;
    cursor: pointer;
  }

  .header-login .line {
    width: 1px;
    height: 34px;
    background-color: #A0A0A0;
    margin: 0 5px;
  }

  /* 顶部 end */
  /* 导航 start */
  .header-nav-btn {
    display: none;
  }

  .header-nav {
    height: 60px;
    background-color: #131313;
  }

  .header-nav .el-menu .nav-items {
    width: 16.66%;
    height: 100%;
    padding: 9px 0 4px 0;
    border: none;
  }

  .header-nav .items {
    width: 100%;
    height: 100%;
    line-height: 47px;
    text-align: center;
    border-left: 1px solid #B8B8BA;
    font-size: 20px;
  }

  .header-nav .nav-items:last-child .items {
    border-right: 1px solid #D2D2D2;
  }

  /* .header-nav .nav-items:hover, */
  .header-nav .nav-items.is-active {
    background: linear-gradient(0deg, rgba(49, 98, 237, 1) 0%, rgba(80, 147, 232, 1) 100%);
  }

  /* .header-nav .nav-items:hover .items, */
  .header-nav .nav-items.is-active .items {
    border-color: transparent;
    font-weight: bold;
    font-family: Source Han Sans CN Bold;
  }

  .web-phone-header {
    display: none;
  }

  .remember-pass {
    margin-top: 15px;
    margin-bottom: -10px;
  }

  .forget-pass {
    line-height: 46px;
    font-size: 16px;
    color: #0861D1;
    cursor: pointer;
  }

  .login-regiater {
    font-size: 16px;
    margin-top: 18px;
    text-align: center;
    color: #666666;
    cursor: pointer;
  }

  .login-regiater span {
    color: #0861D1;
  }

  .web-third-account {
    margin-top: 24px;
  }

  .get-code-box {
    margin-top: 24px;
    height: 27px;
  }

  .get-code {
    min-width: 91px;
    height: 27px;
    line-height: 27px;
    text-align: center;
    background-color: #A0A0A0;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    padding: 0 7px;
  }

  .third-account-title {
    color: #666666;
    font-size: 14px;
    margin-top: 24px;
    text-align: center;
  }

  .third-account-img {
    width: 170px;
    margin: 18px auto 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .third-account-img img {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  /* 导航 end */
  @media screen and (max-width: 800px) {

    /* 搜索列表 start */
    .search-hidden {
      top: 31px;
      padding: 10px 0;
    }

    .search-items {
      height: 26px;
      line-height: 26px;
      padding: 0 10px;
      font-size: 14px;
    }

    .search-hidden .web-space img {
      width: 150px;
    }

    .login-avatar {
      margin: 0;
      margin-top: 3px;
    }

    .login-avatar .avatar {
      width: 30px;
      height: 30px;
    }

    .el-dropdown-menu {
      width: 160px;
    }

    .el-dropdown-menu__item {
      height: 40px;
      font-size: 16px;
      line-height: 40px;
    }

    .web-web-header {
      display: none;
    }

    .web-phone-header {
      width: 100%;
      display: block;
      height: 88px;
      background-color: #131313;
      font-size: 17px;
      position: relative;
      top: 0;
      z-index: 9999;
      font-size: 12px;
    }

    .web-phone-header .phone-nav-top {
      background-color: #FFFFFF;
      height: 44px;
      display: flex;
      padding: 0 22px;
      justify-content: space-between;
      align-items: center;
    }

    .phone-search {
      display: flex;
      position: relative;
    }

    .phone-search .search {
      width: 200px;
      height: 30px;
      background: rgba(220, 220, 220, 1);
      border-radius: 5px 0 0 5px;
      color: #595757;
      font-size: 12px;
      padding: 0 7px;
      line-height: 30px;
      border: 2px solid transparent;
      outline: none;
    }

    .phone-search .search:focus {
      border-color: #0861D1;
    }

    .phone-search .btn {
      width: 30px;
      height: 30px;
      background-color: #0861D1;
      border-radius: 0 5px 5px 0;
      background-image: url(../assets/images/common/search.png);
      background-repeat: no-repeat;
      background-size: 60%;
      background-position: center center;
    }

    .web-phone-header .phone-nav-box {
      height: 44px;
      overflow: hidden;
      display: flex;
      padding: 0 22px;
      justify-content: space-between;
      align-items: center;
      color: #FFFFFF;
    }

    .web-phone-header .line {
      display: block;
      width: 20px;
      height: 2px;
      background: #fff;
      transition: all 0.5s;
    }

    .web-phone-header .line2 {
      margin-top: 6px;
    }

    .web-phone-header .phone-logo {
      width: 26px;
      height: 26px;
    }

    .web-phone-header .phone-navhidden {
      width: 100%;
      background-color: #131313;
      position: absolute;
      top: 88px;
      right: 0;
      box-sizing: border-box;
      padding: 20px 28px 50px 28px;
      display: none;
      color: #FFFFFF;
      border-radius: 0 0 5px 5px;
    }

    .web-phone-header .phone-navhidden li {
      height: 44px;
      line-height: 44px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.6);
    }

    .web-phone-header .el-menu {
      border-right: none;
    }

    .web-phone-header .phone-navhidden li.is-active {
      background: linear-gradient(0deg, rgba(49, 98, 237, 1) 0%, rgba(80, 147, 232, 1) 100%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue